export const WEEKDAYS = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];

export const STATUS = {
  regular: { l: "Regolare", c: "bg-emerald-500/15 text-emerald-700" },
  moved: { l: "Spostata", c: "bg-amber-500/20 text-amber-800" },
  recovery: { l: "Recupero", c: "bg-sky-500/15 text-sky-700" },
  cancelled: { l: "Annullata", c: "bg-red-500/15 text-red-700 line-through" },
};

const toDate = (d) => new Date(`${d}T00:00:00`);

const pad = (n) => String(n).padStart(2, "0");
export const isoDate = (dt) => `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
export const todayIso = () => isoDate(new Date());
export const addDays = (d, n) => { const dt = toDate(d); dt.setDate(dt.getDate() + n); return isoDate(dt); };
export const addMonths = (d, n) => { const dt = toDate(d); dt.setDate(1); dt.setMonth(dt.getMonth() + n); return isoDate(dt); };
export const startOfWeek = (d) => addDays(d, -((toDate(d).getDay() + 6) % 7)); // lunedì
export const monthStart = (d) => `${d.slice(0, 7)}-01`;
export const monthEnd = (d) => { const dt = toDate(monthStart(d)); dt.setMonth(dt.getMonth() + 1); dt.setDate(0); return isoDate(dt); };
export const rangeDays = (from, to) => { const out = []; for (let d = from; d <= to; d = addDays(d, 1)) out.push(d); return out; };

// Es. "gio 12 nov"
export const fmtDay = (d) => toDate(d).toLocaleDateString("it-IT", { weekday: "short", day: "numeric", month: "short" });
// Es. "giovedì 12 novembre"
export const fmtDayHeader = (d) => toDate(d).toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" });
export const fmtMonth = (d) => { const s = toDate(monthStart(d)).toLocaleDateString("it-IT", { month: "long", year: "numeric" }); return s.charAt(0).toUpperCase() + s.slice(1); };

// Colori stabili per corso (in base all'ordine dei corsi dell'anno)
export const COURSE_COLORS = ["#D62728", "#1F77B4", "#2CA02C", "#FF7F0E", "#9467BD", "#8C564B", "#E377C2", "#17BECF",
  "#BCBD22", "#393B79", "#7F7F7F", "#AD494A", "#637939", "#E7BA52", "#5254A3", "#31A354"];
export const courseColorMap = (courses) => Object.fromEntries(courses.map((c, i) => [c, COURSE_COLORS[i % COURSE_COLORS.length]]));

// Permessi (il controllo vero è sul server): master sempre, docente solo sui suoi corsi non bloccati
export const canEditCourse = (meta, user) => !!user && (user.role === "admin"
  || (!!meta && meta.teacher_user_id === user.user_id && !meta.calendar_locked));

export const fmtStamp = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");
export const lastEdit = (x) => (x?.updated_by ? `Ultima modifica: ${x.updated_by.name}, ${fmtStamp(x.updated_at)}` : "");

export const fmtDate = (d) => (d ? toDate(d).toLocaleDateString("it-IT", { weekday: "short", day: "numeric", month: "short", year: "numeric" }) : "—");

export const fmtShort = (d) => (d ? toDate(d).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—");

// Es. "giovedì 13 novembre 2026" (giorno calcolato dalla data)
export const fmtLong = (d) => (d ? toDate(d).toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long", year: "numeric" }) : "");

export const groupByMonth = (lessons) => {
  const groups = [];
  lessons.forEach((x) => {
    const key = x.date.slice(0, 7);
    let g = groups[groups.length - 1];
    if (!g || g.key !== key) {
      const label = toDate(`${key}-01`).toLocaleDateString("it-IT", { month: "long", year: "numeric" });
      g = { key, label: label.charAt(0).toUpperCase() + label.slice(1), items: [] };
      groups.push(g);
    }
    g.items.push(x);
  });
  return groups;
};

export const closureFor = (date, closures) =>
  closures.find((c) => c.start_date <= date && date <= (c.end_date || c.start_date)) || null;

// Coppie di lezioni (non annullate) dello stesso docente che si sovrappongono
export const teacherOverlaps = (lessons) => {
  const ids = new Set();
  const live = lessons.filter((x) => x.status !== "cancelled" && (x.teacher_name || "").trim());
  for (let i = 0; i < live.length; i++) {
    for (let j = i + 1; j < live.length; j++) {
      const a = live[i]; const b = live[j];
      if (a.date !== b.date || a.teacher_name.trim().toLowerCase() !== b.teacher_name.trim().toLowerCase()) continue;
      if (a.start_time < b.end_time && b.start_time < a.end_time) { ids.add(a.id); ids.add(b.id); }
    }
  }
  return ids;
};
